import React from 'react';
import './aboutUs.css';
import ThreeApps from '../../assets/AboutUs.jpg';

const AboutUs = () => {
    return (
        <section id="aboutUs">
            <h1 className="aboutTitle">What we do</h1>
            
            <div className="aboutBars">
                <div className="aboutBar">
                    <img src={ThreeApps} alt="Our mission" className="aboutBarImg" />
                    <div className="aboutBarText">
                        <h2>Our passion is to make rugby accessible globally to everyone</h2>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
